import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    domain:'https://hb.cdzhjk.com/'
  },
  mutations: {

  },
  actions: {

  }
})
